export class ChainingOperationCatalog {
    constructor(
        public id: number,
        public libelle: string,
        public functionId?: number,
        public groupId?: number,
        public chirId?: number
    ) {}
}
